module.exports = __webpack_public_path__ + "media/site/images/svg/logos/ceod-logo-text-colors-37d11c38fecf7cd3a4e5e9a2160321aa.svg";